export type AdminCustomerViewOwnerResource =
  | "user"
  | "configuration"
  | "responses"
  | "account-info"
  | "summary"
  | "positions"
  | "exclusions"
  | "subscriptions";

export function emitAdminCustomerViewOwnerMismatch(
  resource: AdminCustomerViewOwnerResource
): void {
  console.error("[AdminCustomerView] owner mismatch", {
    code: "ADMIN_CUSTOMER_VIEW_OWNER_MISMATCH",
    resource,
  });
}

export class AdminCustomerViewOwnershipError extends Error {
  readonly code = "ADMIN_CUSTOMER_VIEW_OWNER_MISMATCH";

  constructor() {
    super("Customer View could not verify this resource.");
    this.name = "AdminCustomerViewOwnershipError";
  }
}

export function getHttpStatus(error: unknown): number | undefined {
  if (!error || typeof error !== "object") return undefined;
  const candidate = error as { status?: unknown; response?: { status?: unknown } };
  if (typeof candidate.status === "number") return candidate.status;
  if (typeof candidate.response?.status === "number") return candidate.response.status;
  return undefined;
}
